import {
  AxiosResponse,
} from 'axios';
import {
  paths,
} from '../openapi.ts';
import {
  axiosClientBase,
} from '@/api/client';
// @ts-ignore: - potentially unused import
import {
  // @ts-ignore: - potentially unused import
  TApiPayload,
  // @ts-ignore: - potentially unused import
  interpolateUrl,
} from './_utils';
// @ts-ignore: - potentially unused import
import {
  QueryKey,
} from '@tanstack/vue-query';
import {
  getRecipeOnDemandMaterialsEndpoint,
  getRecipeOnDemandRecipesEndpoint,
  getRecipeOnDemandRecipeEndpoint,
  getRecipeOnDemandRecipeProfileEndpoint,
  getRecipeOnDemandRecipeProcessEndpoint,
  getRecipeOnDemandHardnessReferencesEndpoint,
} from './api.endpoints.ts';

export * from './api.endpoints.ts';

export type TGetRecipeOnDemandMaterialsQuery = paths['/api/v1/recipe-on-demand/materials']['get']['parameters']['query'];
export type TGetRecipeOnDemandMaterialsPayload = TApiPayload<undefined, TGetRecipeOnDemandMaterialsQuery, undefined>;
export type TGetRecipeOnDemandMaterialsResponse200 = paths['/api/v1/recipe-on-demand/materials']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandMaterialsResponse = TGetRecipeOnDemandMaterialsResponse200;
export const getRecipeOnDemandMaterialsQueryKey = (query?: TGetRecipeOnDemandMaterialsQuery): QueryKey => ([...["api","v1","recipe-on-demand","materials"], ...(query ? [query] : [])]);
export function getRecipeOnDemandMaterials(payload: TGetRecipeOnDemandMaterialsPayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandMaterialsResponse>> {
  return axiosClientBase.get(getRecipeOnDemandMaterialsEndpoint, { signal: abortSignal, params: payload.query });
}

export type TGetRecipeOnDemandRecipesQuery = paths['/api/v1/recipe-on-demand/recipes']['get']['parameters']['query'];
export type TGetRecipeOnDemandRecipesPayload = TApiPayload<undefined, TGetRecipeOnDemandRecipesQuery, undefined>;
export type TGetRecipeOnDemandRecipesResponse200 = paths['/api/v1/recipe-on-demand/recipes']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandRecipesResponse = TGetRecipeOnDemandRecipesResponse200;
export const getRecipeOnDemandRecipesQueryKey = (query?: TGetRecipeOnDemandRecipesQuery): QueryKey => ([...["api","v1","recipe-on-demand","recipes"], ...(query ? [query] : [])]);
export function getRecipeOnDemandRecipes(payload: TGetRecipeOnDemandRecipesPayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandRecipesResponse>> {
  return axiosClientBase.get(getRecipeOnDemandRecipesEndpoint, { signal: abortSignal, params: payload.query });
}

export type TGetRecipeOnDemandRecipePath = paths['/api/v1/recipe-on-demand/recipes/{recipeId}']['get']['parameters']['path'];
export type TGetRecipeOnDemandRecipePayload = TApiPayload<TGetRecipeOnDemandRecipePath, undefined, undefined>;
export type TGetRecipeOnDemandRecipeResponse200 = paths['/api/v1/recipe-on-demand/recipes/{recipeId}']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandRecipeResponse = TGetRecipeOnDemandRecipeResponse200;
export const getRecipeOnDemandRecipeQueryKey = (recipeId: QueryKey[number]): QueryKey => ([...["api","v1","recipe-on-demand","recipes"], recipeId]);
export function getRecipeOnDemandRecipe(payload: TGetRecipeOnDemandRecipePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandRecipeResponse>> {
  return axiosClientBase.get(interpolateUrl(getRecipeOnDemandRecipeEndpoint, payload.path), { signal: abortSignal });
}

export type TGetRecipeOnDemandRecipeProfilePath = paths['/api/v1/recipe-on-demand/recipes/{recipeId}/profile']['get']['parameters']['path'];
export type TGetRecipeOnDemandRecipeProfilePayload = TApiPayload<TGetRecipeOnDemandRecipeProfilePath, undefined, undefined>;
export type TGetRecipeOnDemandRecipeProfileResponse200 = paths['/api/v1/recipe-on-demand/recipes/{recipeId}/profile']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandRecipeProfileResponse = TGetRecipeOnDemandRecipeProfileResponse200;
export const getRecipeOnDemandRecipeProfileQueryKey = (recipeId: QueryKey[number]): QueryKey => ([...["api","v1","recipe-on-demand","recipes","profile"], recipeId]);
export function getRecipeOnDemandRecipeProfile(payload: TGetRecipeOnDemandRecipeProfilePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandRecipeProfileResponse>> {
  return axiosClientBase.get(interpolateUrl(getRecipeOnDemandRecipeProfileEndpoint, payload.path), { signal: abortSignal });
}

export type TGetRecipeOnDemandRecipeProcessPath = paths['/api/v1/recipe-on-demand/recipes/{recipeId}/process']['get']['parameters']['path'];
export type TGetRecipeOnDemandRecipeProcessPayload = TApiPayload<TGetRecipeOnDemandRecipeProcessPath, undefined, undefined>;
export type TGetRecipeOnDemandRecipeProcessResponse200 = paths['/api/v1/recipe-on-demand/recipes/{recipeId}/process']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandRecipeProcessResponse = TGetRecipeOnDemandRecipeProcessResponse200;
export const getRecipeOnDemandRecipeProcessQueryKey = (recipeId: QueryKey[number]): QueryKey => ([...["api","v1","recipe-on-demand","recipes","process"], recipeId]);
export function getRecipeOnDemandRecipeProcess(payload: TGetRecipeOnDemandRecipeProcessPayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandRecipeProcessResponse>> {
  return axiosClientBase.get(interpolateUrl(getRecipeOnDemandRecipeProcessEndpoint, payload.path), { signal: abortSignal });
}

export type TGetRecipeOnDemandHardnessReferencesResponse200 = paths['/api/v1/recipe-on-demand/hardness-references']['get']['responses']['200']['content']['application/json'];
export type TGetRecipeOnDemandHardnessReferencesResponse = TGetRecipeOnDemandHardnessReferencesResponse200;
export const getRecipeOnDemandHardnessReferencesQueryKey = (): QueryKey => ([...["api","v1","recipe-on-demand","hardness-references"]]);
export function getRecipeOnDemandHardnessReferences(abortSignal?: AbortSignal): Promise<AxiosResponse<TGetRecipeOnDemandHardnessReferencesResponse>> {
  return axiosClientBase.get(getRecipeOnDemandHardnessReferencesEndpoint, { signal: abortSignal });
}

